module.exports = __webpack_public_path__ + "img/hotpot.07f27acf.png";